/* ============================================================
   CRINÉOL · Carrousels animés (photos clients et cartes d'avis)

   POURQUOI CE FICHIER PREND AUSSI LA MAIN SUR LES FLÈCHES
   -------------------------------------------------------
   crineol.js câble les flèches sur rail.scrollBy({behavior:'smooth'}).
   Or ce fichier anime le même rail en écrivant scrollLeft à chaque
   frame. Deux propriétaires pour une seule valeur : chaque écriture
   annulait le scroll fluide en cours, et les flèches ne faisaient
   rien. Inutile d'essayer de fiabiliser ça à coups de pauses : tant
   que les deux systèmes écrivent, le résultat dépend de l'ordre des
   frames. Ce script est donc le seul propriétaire de la position.

   Deux autres pièges traités ici :
   - scroll-snap-type:x mandatory recolle sur le point d'accroche à
     chaque frame et fige toute animation : on le désactive.
   - requestAnimationFrame ne se déclenche pas quand l'onglet n'est
     pas peint. Sans filet, un clic sur une flèche ne ferait alors
     rien du tout : on applique le déplacement immédiatement tant
     qu'aucune frame n'a été servie.
   ============================================================ */
(function () {
  'use strict';

  var VITESSE = 0.35;   // pixels par frame en défilement libre
  var PAUSE   = 3500;   // ms d'arrêt après une action de l'utilisateur
  var GLISSE  = 0.16;   // souplesse de l'animation des flèches

  function installer(rail, bloc) {
    var elements = Array.prototype.slice.call(rail.children);
    if (!elements.length) return;

    elements.forEach(function (noeud) {
      var clone = noeud.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      rail.appendChild(clone);
    });

    rail.classList.add('auto');
    rail.style.scrollSnapType = 'none';
    Array.prototype.forEach.call(rail.children, function (n) {
      n.style.scrollSnapAlign = 'none';
    });

    var survol = false;
    var repriseA = 0;
    var moitie = 0;
    var cible = null;
    var pos = rail.scrollLeft;
    var derniereEcriture = -1;
    var rafVivant = false;

    function mesurer() { moitie = rail.scrollWidth / 2; }
    mesurer();
    window.addEventListener('resize', mesurer);
    if (window.ResizeObserver) new ResizeObserver(mesurer).observe(rail);

    function suspendre() { repriseA = Date.now() + PAUSE; }
    function pas() { return Math.max(240, rail.clientWidth * 0.8); }

    function ecrire() {
      if (moitie > 0) {
        // Les clones rendent la boucle invisible : on replie la position
        // dans la première moitié, en emmenant la cible avec elle.
        while (pos >= moitie) { pos -= moitie; if (cible !== null) cible -= moitie; }
        while (pos < 0)       { pos += moitie; if (cible !== null) cible += moitie; }
      }
      rail.scrollLeft = pos;
      derniereEcriture = rail.scrollLeft;
    }

    function aller(sens) {
      var depart = (cible === null) ? rail.scrollLeft : cible;
      pos = (cible === null) ? rail.scrollLeft : pos;
      cible = depart + sens * pas();
      suspendre();
      if (!rafVivant) { pos = cible; cible = null; ecrire(); }
    }

    ['pointerenter', 'focusin'].forEach(function (e) {
      rail.addEventListener(e, function () { survol = true; }, { passive: true });
    });
    ['pointerleave', 'focusout'].forEach(function (e) {
      rail.addEventListener(e, function () { survol = false; }, { passive: true });
    });
    ['pointerdown', 'touchstart', 'touchmove', 'wheel'].forEach(function (e) {
      rail.addEventListener(e, function () { cible = null; suspendre(); }, { passive: true });
    });

    if (bloc) {
      var prec = bloc.querySelector('[data-rail-prev]');
      var suiv = bloc.querySelector('[data-rail-next]');
      if (prec) prec.addEventListener('click', function () { aller(-1); });
      if (suiv) suiv.addEventListener('click', function () { aller(1); });
    }

    var visible = true;
    if ('IntersectionObserver' in window) {
      visible = false;
      new IntersectionObserver(function (entrees) {
        entrees.forEach(function (en) { visible = en.isIntersecting; });
      }, { threshold: 0 }).observe(rail);
    }

    var sobre = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function frame() {
      rafVivant = true;

      // Le rail a bougé sans nous (doigt, molette, clavier) : on adopte sa position.
      if (Math.abs(rail.scrollLeft - derniereEcriture) > 1 && cible === null) {
        pos = rail.scrollLeft;
      }

      if (cible !== null) {
        // Glissade commandée par une flèche : prioritaire sur tout le reste.
        pos += (cible - pos) * GLISSE;
        if (Math.abs(cible - pos) < 0.8) { pos = cible; cible = null; suspendre(); }
        ecrire();
      } else if (!sobre && !survol && visible && moitie > 0 && Date.now() >= repriseA) {
        pos += VITESSE;
        ecrire();
      }
      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-rail]')).forEach(function (bloc) {
      var rail = bloc.querySelector('.rail');
      if (!rail) return;
      if (rail.querySelector('.rcard') || rail.querySelector('.ugc')) installer(rail, bloc);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
